function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.766 3.102a2.926 2.926 0 00-1.53 0A2.994 2.994 0 0013.13 5.22a3.004 3.004 0 000 1.56v.002L15.856 17h.285L18.87 6.782a2.998 2.998 0 000-1.56 2.989 2.989 0 00-2.104-2.12zm-2.065-1.93a4.976 4.976 0 012.596 0h.001a5 5 0 013.53 6.12L18.102 17.51A2.021 2.021 0 0116.142 19h-.285c-.92 0-1.724-.612-1.959-1.49L11.17 7.293a4.982 4.982 0 010-2.582 5.006 5.006 0 013.53-3.538zM16 23a2.987 2.987 0 00-2.974 3c0 1.672 1.347 3 2.974 3a2.987 2.987 0 002.974-3c0-1.673-1.347-3-2.974-3zm-5 3A5 5 0 1121 26a5 5 0 11-9.998 0z",
  fill: "currentColor"
})));